import React from 'react';
import { Page as TemplatePage, ContentArea, Main, Body } from '@cvent/carina/components/Templates';
import Head from 'next/head';

import { PageContainer } from '@components/containers/PageContainer';

export const Layout = ({ children }): JSX.Element => {
  return (
    <TemplatePage testID={'cvent_layout'}>
      <Main as="div">
        <Head>
          <title>Login</title>
        </Head>
        <Body>
          <ContentArea>
            <PageContainer testID={'cvent_page'}>{children}</PageContainer>
          </ContentArea>
        </Body>
      </Main>
    </TemplatePage>
  );
};
